import type {
	CustomItem,
	DropTheCurrencyAntiCounterfeintingType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropTheCurrencyAntiCounterfeinting = (
	item: Item | CustomItem
): item is DropTheCurrencyAntiCounterfeintingType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Anti_Counterfeiting_Interactive_Component'
	);
};
